import { Dialog, DialogContent, Grid } from '@material-ui/core';
import React, { FunctionComponent, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import Texto from '@infotrack/presentacion-componentes/texto';
import { manejadorDialogoGlobal } from '@infotrack/presentacion-utilitarios/manejadoresComponentes';

import IDocumentoConsultaGeneral, {
    DOCUMENTO_CONSULTA_GENERAL_POR_DEFECTO,
} from 'Infotrack@Modelos/negocioRefactor/entidades/consulta/IDocumentoConsultaGeneral';
import IDocumentoDetalleConsultaGeneral from 'Infotrack@Modelos/negocioRefactor/entidades/consulta/IDocumentoDetalleConsultaGeneral';
import IDocumento from 'Infotrack@Modelos/negocioRefactor/entidades/repositorio/IDocumento';
import IDocumentoDetalle from 'Infotrack@Modelos/negocioRefactor/entidades/repositorio/IDocumentoDetalle';
import TiposProceso from 'Infotrack@Modelos/negocioRefactor/enumeraciones/TiposProceso';
import IBodega from 'Infotrack@Modelos/smartStock/bodegas/entidades/bodega';
import IBodegaDivisiones from 'Infotrack@Modelos/smartStock/bodegasDivisiones/entidades/bodegasDivisiones';
import IEtapas from 'Infotrack@Modelos/smartStock/etapas/entidades/etapas';
import IItemsConsulta from 'Infotrack@Modelos/smartStock/items/entidades/IItemsConsulta';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import DetallesFormulario from 'Infotrack@Transversales/componentes/DetallesFormularioTabla/DetallesFormulario';
import EstadosDetallesFormulario from 'Infotrack@Transversales/componentes/DetallesFormulario/enumeraciones';
import DocumentoBuscador from 'Infotrack@Transversales/componentes/DocumentoBuscador/DocumentoBuscador';
import DocumentoValorTotal from 'Infotrack@Transversales/componentes/DocumentoValorTotal/DocumentoValorTotal';
import { EstadosFormularioDocumento } from 'Infotrack@Transversales/componentes/FormularioDocumento/enumeraciones';
import FormularioDocumento, {
    IEntidadesFormularioDocumento,
} from 'Infotrack@Transversales/componentes/FormularioDocumento/FormularioDocumento';
import ModalEncabezado from 'Infotrack@Transversales/componentes/ModalEncabezado/ModalEncabezado';
import TablaDetalles from 'Infotrack@Transversales/componentes/TablaDetalles/TablaDetalles';
import TablaDetallesPlantilla from 'Infotrack@Transversales/componentes/TablaDetallesPlantilla/TablaDetallesPlantilla';

import {
    CAMPOS_DESHABILITAR_DETALLES_FORMULARIO,
    CAMPOS_DESHABILITAR_DOCUMENTO_FORMULARIO,
    CAMPOS_DESHABILITAR_DOCUMENTO_FORMULARIO_DOCUMENTO_BASE,
    CAMPOS_DESHABILITAR_DOCUMENTO_FORMULARIO_EDICION,
    CAMPOS_EDITABLES_DETALLES_PLANTILLA,
    CAMPOS_OCULTAR_DETALLES_FORMULARIO,
    CAMPOS_OCULTAR_DETALLES_PLANTILLA,
    CAMPOS_OCULTAR_DETALLES_TABLA,
    CAMPOS_OCULTAR_DOCUMENTO_FORMULARIO,
    ENTIDADES_DOCUMENTO_POR_DEFECTO,
} from './constantes';
import EntidadesDetalleCM from './controladorModelo/EntidadesDetalleCM';
import EntidadesDocumentoCM from './controladorModelo/EntidadesDocumentoCM';
import SalidaDevolucionCM from './controladorModelo/SalidaDevolucionCM';
import { EstadosModalSalidaDevolucion } from './enumeraciones';
import { estadoActivo } from 'Infotrack@Transversales/constantes/ConstantesEstados';
import DocumentoFirma from 'Infotrack@Transversales/componentes/DocumentoFirma/DocumentoFirma';
import Etapas from 'Infotrack@Modelos/negocioRefactor/enumeraciones/Etapas';


interface IModalSalidaDevolucionProps {
    cerrar: () => void;
    documentoId: string | null;
    establecerDocumentoId: (documentoId: string) => void;
    estado: EstadosModalSalidaDevolucion;
    descargarDocumentoPdf: (documento: IDocumentoConsultaGeneral) => any;
    cambiarEstado: () => void;
}

const ModalSalidaDevolucion: FunctionComponent<IModalSalidaDevolucionProps> = ({
    cerrar,
    documentoId,
    establecerDocumentoId,
    estado,
    descargarDocumentoPdf,
    cambiarEstado,
}) => {
    const entidadesDocumentoCM = useMemo(() => new EntidadesDocumentoCM(), []);
    const salidaDevolucionCM = useMemo(() => new SalidaDevolucionCM(), []);
    const entidadesDetalleCM = useMemo(() => new EntidadesDetalleCM(), []);
    const idEmpresa = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.usuarioInformacion!.IdEmpresa);
    const idAgencia = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.agenciaActual!.IdAgencia);
    const idUsuario = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.usuarioInformacion!.IdUsuario);
    const  usuario = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.usuarioInformacion);
    const idAplicacion = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.usuarioInformacion!.IdAplicacion);
    const [detalleInicialEdicion, setDetalleInicialEdicion] = useState<IDocumentoDetalle | null>(null);
    const [DocumentoDetallesBase, setDocumentoDetallesBase] = useState<IDocumentoDetalleConsultaGeneral[]>([]);
    const [entidadesDocumento, setEntidadesDocumento] = useState<Partial<IEntidadesFormularioDocumento>>(
        ENTIDADES_DOCUMENTO_POR_DEFECTO
    );
    const [documento, setDocumento] = useState<IDocumentoConsultaGeneral | null>(null);
    const [etapasSiguientes, setEtapasSiguientes] = useState<IEtapas[]>([]);
    const [entidadesDetalle, setEntidadesDetalle] = useState<{
        divisionesOrigen: IBodegaDivisiones[];
        bodegasOrigen: IBodega[];
    }>({ divisionesOrigen: [], bodegasOrigen: [] });
    const [detalles, setDetalles] = useState<IDocumentoDetalleConsultaGeneral[]>([]);
    const [abrirModalActa, setAbrirModalActa] = useState<boolean>(false);
    const [etapaSeleccionada, setEtapaSeleccionada] = useState<number>(0);

    useEffect(() => {
        alCambiarEstado();
    }, [estado]);

    useEffect(() => {
        if (documento) alEstablecerDocumento();
    }, [documento]);

    const alCambiarEstado = async () => {
        if (estado === EstadosModalSalidaDevolucion.CERRADO) {
            setDocumento(null);
            setDetalles([]);
            setEntidadesDocumento(ENTIDADES_DOCUMENTO_POR_DEFECTO);
            setEtapasSiguientes([]);
            setEntidadesDetalle({ divisionesOrigen: [], bodegasOrigen: [] });
            setDetalleInicialEdicion(null);
            setDocumentoDetallesBase([]);
        }
        if (estado === EstadosModalSalidaDevolucion.CREACION) {
            setDocumentoDetallesBase([]);
            await consultarEntidadesDocumento();
        }
        if (estado === EstadosModalSalidaDevolucion.EDICION || estado === EstadosModalSalidaDevolucion.VISUALIZACION) {
            await consultarDocumento(documentoId!);
        }
    };
    const consultarEntidadesDocumento = async () => {
        const entidadesDocumentoConsultadas = await entidadesDocumentoCM.consultarEntidadesDocumento(
            idEmpresa,
            idAgencia,
            usuario!.NombrePerfil!!=="Administrador"? idUsuario:"",
            estadoActivo
        );
        setEntidadesDocumento(entidadesDocumentoConsultadas);
    };

    const consultarEntidadesDocumentoEdicion = async () => {
        const entidadesDocumentoConsultadas = await entidadesDocumentoCM.consultarEntidadesDocumentoEdicion(
            documento!.BodegaOrigen!,
            idEmpresa,
            idAgencia,
            usuario!.NombrePerfil!!=="Administrador"? idUsuario:"",
            TiposProceso.SALIDA_POR_DEVOLUCION,
            estadoActivo
        );
        setEntidadesDocumento(entidadesDocumentoConsultadas);
    };

    const consultarDocumento = async (documentoIdConsultar: string) => {
        const documentoConsultado = await salidaDevolucionCM.consultarEncabezadoDocumento({
            DocumentoId: documentoIdConsultar,
        });
        setDocumento(documentoConsultado);
    };

    const alEstablecerDocumento = async () => {
        if (estado === EstadosModalSalidaDevolucion.CREACION) {
            if (documento!.DocumentoId) {
                establecerDocumentoId(documento!.DocumentoId);
                await consultarEtapasSiguientes();
                await consultarEntidadesDetalle();
                await consultarDetallesDocumentoBase();
            }
        }
        if (estado === EstadosModalSalidaDevolucion.EDICION) {
            await consultarEtapasSiguientes();
            await consultarEntidadesDetalleEdicion();
            await consultarDetallesDocumentoBase();
            await consultarDetalles();
            await consultarEntidadesDocumentoEdicion();
        }
        if (estado === EstadosModalSalidaDevolucion.VISUALIZACION) {
            await consultarEntidadesDetalle();
            await consultarDetallesDocumentoBase();
            await consultarDetalles();
            await consultarEntidadesDocumentoEdicion();
        }
    };

    const consultarEntidadesDetalle = async () => {
        const entidadesDetalleConsultadas = await entidadesDetalleCM.consultarEntidadesDetalle(
            documento!.BodegaOrigen!,
            documento!.TipoDocumentoId,
            idEmpresa,
            idAgencia,
            idUsuario
        );
        setEntidadesDetalle(entidadesDetalleConsultadas);
    };

    const consultarEntidadesDetalleEdicion = async () => {
        const entidadesDetalleConsultadas = await entidadesDetalleCM.consultarEntidadesDetalleEdicion(
            documento!.BodegaOrigen!,
            documento!.TipoDocumentoId,
            idEmpresa,
            idAgencia,
            idUsuario
        );
        setEntidadesDetalle(entidadesDetalleConsultadas);
    };

    const consultarDetalles = async () => {
        const detallesConsultados = await salidaDevolucionCM.consultarDetallesDocumento({ DocumentoId: documentoId! });
        setDetalles(detallesConsultados);
    };

    const consultarEtapasSiguientes = async () => {
        const etapasSiguientesConsultadas = await salidaDevolucionCM.consultarEtapas(documento!.DocumentoId);
        setEtapasSiguientes(etapasSiguientesConsultadas);
    };

    const crearDocumento = async (documentoCrear: IDocumento) => {
        const respuesta = await salidaDevolucionCM.guardarEncabezado(mapearDocumentoCrear(documentoCrear));
        if (respuesta.Resultado) {
            await consultarDocumento(respuesta.Entidades[0].DocumentoId);
            await consultarDetallesDocumentoBase();
            await cambiarEstado();
        }
    };

    const mapearDocumentoCrear = (documentoCrear: IDocumento): IDocumento => {
        return {
            ...documentoCrear,
            EmpresaId: idEmpresa,
            AgenciaId: idAgencia,
        };
    };

    const editarDocumento = async (documentoEditar: IDocumento) => {
        const respuesta = await salidaDevolucionCM.editarEncabezado(documentoEditar);
        if (respuesta.Resultado) {
            await consultarDocumento(documento!.DocumentoId);
        }
    };

    const cambiarEtapa = async (etapaId: number) => {
        if ( await consultasAccionesTipoDocumento(documento!.TipoDocumentoId,etapaId) === false ) {
            manejadorDialogoGlobal({ estado: false });
            const cambioEtapaExitoso = await salidaDevolucionCM.cambiarEtapa({ ...documento!, EtapaId: etapaId }, idUsuario);
            if (cambioEtapaExitoso) {
                if(etapaId === Etapas.FINALIZADA) salidaDevolucionCM.guardarDocumentoFirma({ AplicacionId: idAplicacion,DocumentoId: documentoId!, FirmaBase64: "" })
                await consultarDocumento(documento!.DocumentoId);
            }
        } else {
            setEtapaSeleccionada(etapaId)
        }

    };

    const consultasAccionesTipoDocumento = async (idTipoDocumento: number, idEtapa: number) => {
        debugger
        const acciones = await entidadesDocumentoCM.consultarAccionEtapaDocumentoFiltro(idTipoDocumento, idEtapa);
        if (acciones[0].EtapaDescripcion ==="Finalizado" && acciones[0].GenerarActa) {
            setAbrirModalActa(true)
            return true;
        }
        else {
            return false;
        }
    }

    const confirmarCambiarEtapa = async (etapaId: number) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => cambiarEtapa(etapaId),
            estado: true,
            mensaje: <Texto id={'etapas.CambioEtapa'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };

    const editarDetalle = async (detalle: IDocumentoDetalle) => {
        return salidaDevolucionCM.editarDetalle(detalle);
    };

    const eliminarDetalle = async (detalle: IDocumentoDetalle) => {
        manejadorDialogoGlobal({ estado: false });
        const respuesta = await salidaDevolucionCM.eliminarDetalle(detalle);
        if (respuesta) {
            setDetalleInicialEdicion(null);
            await consultarDetallesDocumentoBase();
            await consultarDetalles();
        }
    };

    const consultarDetallesDocumentoBase = async () => {
        if (documento! && documento!.BodegaOrigen!) {
            const detallesBase = await salidaDevolucionCM.consultarDetallesDocumentoBase(
                documento!.DocumentoPredecesorId!,
                documento!.BodegaOrigen!,
            );
            setDocumentoDetallesBase(mapearDestallesBase(detallesBase));
        }
    };

    const consultaDocumentoBase = async (codigoDocumentoBase: string) => {
        const documentoBase = await salidaDevolucionCM.consultarDocumentoBase({
            CodigoDocumento: codigoDocumentoBase,
            IdAgencia: idAgencia,
            IdEmpresa: idEmpresa
        });
        if (documentoBase) setDocumento(mapearDocumentoBase(documentoBase));
        return documentoBase;
    };

    const mapearDestallesBase = (detalles: IDocumentoDetalleConsultaGeneral[]): IDocumentoDetalleConsultaGeneral[] => {
        const detallesBase: IDocumentoDetalleConsultaGeneral[] = detalles.map((d) => ({
            DocumentoDetalleId: d.DocumentoDetalleId,
            DocumentoId: d.DocumentoId,
            ItemId: d.ItemId,
            DivisionOrigen: d.DivisionOrigen,
            CantidadSolicitada: d.CantidadSolicitada,
            CantidadRecibida: d.CantidadRecibida,
            CantidadEntregada: d.CantidadEntregada,
            Valor: d.Valor,
            Serial: d.Serial,
            Lote: d.Lote,
            FechaVencimiento: d.FechaVencimiento,
            FechaIngreso: d.FechaIngreso,
            DocumentoDetallePredecesorId: d.DocumentoDetallePredecesorId,
            EmpresaId: d.EmpresaId,
            AgenciaId: d.AgenciaId,
            Estado: d.Estado,
            CodigoBarras: d.CodigoBarras,
            DescripcionDivisionDestino: d.DescripcionDivisionDestino,
            DescripcionDivisionOrigen: d.DescripcionDivisionOrigen,
            DescripcionItem: d.DescripcionItem,
            CodigoDocumento: d.CodigoDocumento,
            DescripcionEstadoDetalle: d.DescripcionEstadoDetalle,
            FEFO: d.FEFO,
            FIFO: d.FIFO,
            Lotes: d.Lotes,
        }));
        console.table(detallesBase);
        return detallesBase;
    };

    const mapearDocumentoBase = (documentoBase: IDocumento): IDocumentoConsultaGeneral => {
        return {
            ...DOCUMENTO_CONSULTA_GENERAL_POR_DEFECTO,
            ClienteId: documentoBase.ClienteId,
            CodigoDocumentoPredecesor: documentoBase.CodigoDocumento,
            CondicionComercial: documentoBase.CondicionComercial,
            DireccionEntrega: documentoBase.DireccionEntrega,
            DocumentoPredecesorId: documentoBase.DocumentoId,
            DocumentoRelacionado: documentoBase.DocumentoRelacionado,
            FechaEntrega: documentoBase.FechaEntrega,
            Observacion: documentoBase.Observacion,
            ProveedorId: documentoBase.ProveedorId,
        };
    };

    const agregarDetalles = async (detallesAgregar: IDocumentoDetalle[]) => {
        const respuesta = await salidaDevolucionCM.guardarDetalle(
            detallesAgregar.map((detalle) => ({
                ...detalle,
                DocumentoDetalleId: '',
                DocumentoDetallePredecesorId: detalle.DocumentoDetallePredecesorId!,
                DocumentoId: documento!.DocumentoId,
            }))
        );
        consultarDetalles();
        return respuesta;
    };

    const confirmarEliminarDetalle = async (detalle: IDocumentoDetalle) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarDetalle(detalle),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };

    const consultarTipoDocumento = async (idBodega: number, nombreNodega?: string) => {
        if (nombreNodega === 'BodegaOrigen') {
            const tiposDocumentosBodega = await entidadesDocumentoCM.consultarTipoDocumento(idBodega, estadoActivo);
            setEntidadesDocumento({ ...entidadesDocumento, tiposDocumento: tiposDocumentosBodega });
        }
    };

    const consultarItemsTabla = async (idItem: number) => {
        const items = await entidadesDetalleCM.consultarItem(
            idItem,
            idEmpresa
        );
        return items.itemsConsulta;
    };

    const consultarFirmas = () => { }

    const guardarFirmas = async (firma: File) => {

        const respuesta = await entidadesDocumentoCM.guardarFirmaArchivo({ IdAplicacion: idAplicacion, ExtensionArchivo: 2, NombreArchivo: firma.name, RutaAlmacenamiento: `${idAplicacion}/Firma/${documentoId}`, Identificador: documentoId! }, firma)
        if (respuesta) {
            manejadorDialogoGlobal({ estado: false });
            const cambioEtapaExitoso = await salidaDevolucionCM.cambiarEtapa({ ...documento!, EtapaId: etapaSeleccionada , PersonaRelacionada:idUsuario},idUsuario);
            if (cambioEtapaExitoso) {
                await consultarDocumento(documento!.DocumentoId);
                setAbrirModalActa(false);
            }
        }

    }

    const cerrarDocumentoFirma = () => {
        setAbrirModalActa(false)
    }
    return (
        <Dialog open={estado !== EstadosModalSalidaDevolucion.CERRADO} maxWidth="lg">
            <ModalEncabezado
                cerrar={cerrar}
                titulo={
                    estado === EstadosModalSalidaDevolucion.CREACION ? (
                        <Texto id="ModalSalidaDevolucion.TituloCreacion" />
                    ) : estado === EstadosModalSalidaDevolucion.EDICION ? (
                        <Texto id="ModalSalidaDevolucion.TituloEdicion" />
                    ) : estado === EstadosModalSalidaDevolucion.VISUALIZACION ? (
                        <Texto id="ModalSalidaDevolucion.TituloVisualizacion" />
                    ) : (
                        undefined
                    )
                }
            />
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        {(!documento || !documento.DocumentoId) && (
                            <DocumentoBuscador consultaDocumentoBase={consultaDocumentoBase} esEntradaDevolucion={false}/>
                        )}
                    </Grid>
                    {documento && (
                        <Grid item xs={12}>
                            <FormularioDocumento
                                cambiarEtapa={confirmarCambiarEtapa}
                                camposDeshabilitar={
                                    estado === EstadosModalSalidaDevolucion.CREACION
                                        ? CAMPOS_DESHABILITAR_DOCUMENTO_FORMULARIO_DOCUMENTO_BASE
                                        : CAMPOS_DESHABILITAR_DOCUMENTO_FORMULARIO_EDICION
                                }
                                camposOcultar={CAMPOS_OCULTAR_DOCUMENTO_FORMULARIO}
                                editarDocumento={editarDocumento}
                                etapasSiguientes={etapasSiguientes}
                                estado={
                                    !documento || !documento.DocumentoId
                                        ? EstadosFormularioDocumento.CREACION
                                        : (estado === EstadosModalSalidaDevolucion.CREACION &&
                                              documento &&
                                              documento.DocumentoId) ||
                                          estado === EstadosModalSalidaDevolucion.EDICION
                                        ? EstadosFormularioDocumento.EDICION
                                        : EstadosFormularioDocumento.VISUALIZACION
                                }
                                documento={documento}
                                entidadesDocumento={entidadesDocumento}
                                guardarDocumento={crearDocumento}
                                descargarDocumentoPdf={descargarDocumentoPdf}
                                consultarTipoDocumento={consultarTipoDocumento}
                                mostrarModalEvidencia={true}
                                esTraslado={false}
                            />
                        </Grid>
                    )}
                    {documento && documento.DocumentoId && (
                        <Grid item xs={12}>
                            <TablaDetallesPlantilla
                                agregarDetalles={agregarDetalles}
                                camposOcultar={CAMPOS_OCULTAR_DETALLES_PLANTILLA}
                                camposEditables={CAMPOS_EDITABLES_DETALLES_PLANTILLA}
                                deshabilitada={
                                    !documento ||
                                    !documento.ListaAcciones.PermiteAgregarDetalle ||
                                    estado === EstadosModalSalidaDevolucion.VISUALIZACION
                                }
                                tipoCantidad={'CantidadEntregada'}
                                detalles={DocumentoDetallesBase}
                                entidades={entidadesDetalle}
                                titulo={
                                    <Texto
                                        fontWeight="bold"
                                        id="ModalSalidaDevolucion.TituloTablaDetallesDocumentoBase"
                                    />
                                }
                                seriadoConsulta={false}
                                manejaPeso={false}
                                esEntrada={false}
                            />
                        </Grid>
                    )}
                    {estado !== EstadosModalSalidaDevolucion.VISUALIZACION && (
                        <Grid item xs={12}>
                            <DetallesFormulario
                                alEditarDetalle={async () => {
                                    setDetalleInicialEdicion(null);
                                    await consultarDetalles();
                                }}
                                camposDeshabilitar={CAMPOS_DESHABILITAR_DETALLES_FORMULARIO}
                                camposOcultar={CAMPOS_OCULTAR_DETALLES_FORMULARIO}
                                deshabilitado={!detalleInicialEdicion}
                                detalleInicialEdicion={detalleInicialEdicion}
                                documentoId={documento ? documento.DocumentoId : ''}
                                editarDetalle={editarDetalle}
                                entidades={entidadesDetalle}
                                estado={EstadosDetallesFormulario.EDICION}
                                tipoCantidad="CantidadEntregada"
                                seriadoConsulta={false}
                                esEntradaInventario={false}
                                documentoDetallesBase={DocumentoDetallesBase}
                                bloquearCantidadSerial={true}
                                esOrdenTraslado={false}
                                consultarItems={consultarItemsTabla}
                            />
                        </Grid>
                    )}
                    <Grid item xs={12}>
                        <TablaDetalles
                            camposOcultar={CAMPOS_OCULTAR_DETALLES_TABLA}
                            detalles={detalles}
                            editarDetalle={(detalle: IDocumentoDetalleConsultaGeneral) =>
                                setDetalleInicialEdicion(detalle)
                            }
                            editarDetalleDeshabilitado={
                                documento ? !documento.ListaAcciones.PermiteEditarDetalle : false
                            }
                            eliminarDetalle={confirmarEliminarDetalle}
                            eliminarDetalleDeshabilitado={
                                documento ? !documento.ListaAcciones.PermiteEliminarDetalle : false
                            }
                            mostrarAcciones={
                                documento !== null && documento.DocumentoPredecesorId !== null ? true : false
                            }
                            recargarTabla={consultarDetalles}
                            titulo={<Texto fontWeight="bold" id="ModalSalidaDevolucion.TituloTablaDetalles" />}
                        />
                    </Grid>
                    {abrirModalActa && (
                        <Grid item xs={12}>
                            <DocumentoFirma
                                consultarFirmas={consultarFirmas}
                                guardarFirmas={guardarFirmas}
                                idDocumento={documento ? documento.DocumentoId : ""}
                                cerrarDocumentoFirma={cerrarDocumentoFirma}
                            />
                        </Grid>)

                    }
                    <Grid item xs={12}>
                        <DocumentoValorTotal detalles={detalles} />
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default ModalSalidaDevolucion;
